import { exploreToolsConfigRef } from '@backstage-community/plugin-explore-react';
import { exploreRouteRef, catalogEntityRouteRef } from './routes.esm.js';
import { createPlugin, createApiFactory, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';
import { ExploreClient } from './api/ExploreClient.esm.js';
import { exploreApiRef } from './api/ExploreApi.esm.js';

const explorePlugin = createPlugin({
  id: "explore",
  apis: [
    createApiFactory({
      api: exploreApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        exploreToolsConfig: exploreToolsConfigRef
      },
      factory: ({ discoveryApi, fetchApi, exploreToolsConfig }) => (
        // NOTE: The exploreToolsConfig is for backwards compatibility and will be removed in the future
        new ExploreClient({ discoveryApi, fetchApi, exploreToolsConfig })
      )
    }),
    /**
     * @deprecated Use ExploreApi from `@backstage-community/plugin-explore` instead
     *
     * Register a default for exploreToolsConfigRef, you may want to override
     * the API locally in your app.
     */
    createApiFactory({
      api: exploreToolsConfigRef,
      deps: {},
      factory: () => ({
        async getTools() {
          return void 0;
        }
      })
    })
  ],
  routes: {
    explore: exploreRouteRef
  },
  externalRoutes: {
    catalogEntity: catalogEntityRouteRef
  }
});
const ToolSearchResultListItem = explorePlugin.provide(
  createSearchResultListItemExtension({
    name: "ToolSearchResultListItem",
    component: () => import('./components/ToolSearchResultListItem/index.esm.js').then(
      (m) => m.ToolSearchResultListItem
    ),
    predicate: (result) => result.type === "tools"
  })
);

export { ToolSearchResultListItem, explorePlugin };
//# sourceMappingURL=plugin.esm.js.map
